
import BDWidget from '../Widget'
import DomUtil from '../../utils/DomUtil'

const geodesic = new Cesium.EllipsoidGeodesic()

const BASE = [1, 2, 3, 5]

const DIS = [
    ...BASE,
    ...BASE.map(item => item * 10),
    ...BASE.map(item => item * 100),
    ...BASE.map(item => item * 1000),
    ...BASE.map(item => item * 10000),
    ...BASE.map(item => item * 100000),
    ...BASE.map(item => item * 1000000)
]

/**
 * 比例尺
 */
class DistanceLegend extends BDWidget {
    constructor() {
        super()
        this._lastUpdate = Cesium.getTimestamp();
    }

    getType() {
        return "distanceLegend"
    }

    mountContent() {
        this._wrapper = DomUtil.create('div', 'bd-distance-legend');
        this._labelEl = DomUtil.create('div', 'label', this._wrapper)
        this._scaleBarEl = DomUtil.create('div', 'scale-bar', this._wrapper)
        this.hide();
    }

    updateContent() {

        let now = Cesium.getTimestamp()
        if (now < this._lastUpdate + 250) {
            return
        }

        var scene = this.viewer.scene;
        this._lastUpdate = now
        let width = scene.canvas.width
        let height = scene.canvas.height / 2
        let left = scene.camera.getPickRay(
            new Cesium.Cartesian2((width / 2) | 0, height)
        )
        let right = scene.camera.getPickRay(
            new Cesium.Cartesian2((1 + width / 2) | 0, height)
        )
        let leftPosition = scene.globe.pick(left, scene)
        let rightPosition = scene.globe.pick(right, scene)
        if (!leftPosition || !rightPosition) {
            return
        }
        geodesic.setEndPoints(
            scene.globe.ellipsoid.cartesianToCartographic(leftPosition),
            scene.globe.ellipsoid.cartesianToCartographic(rightPosition)
        )
        let pixelDistance = geodesic.surfaceDistance
        let maxBarWidth = 100
        let distance = 0
        for (let i = DIS.length - 1; i >= 0; --i) {
            if (DIS[i] / pixelDistance < maxBarWidth) {
                distance = DIS[i]
                break
            }
        }

        if (distance) {
            this._labelEl.innerHTML =
                distance >= 1000 ? `${distance / 1000} km` : `${distance} m`
            let barWidth = (distance / pixelDistance) | 0
            this._scaleBarEl.style.cssText = `width: ${barWidth}px; left: ${(125 -
                barWidth) /
                2}px;`
        }
    }

}

export default DistanceLegend